import { Address, SubmitPrequalRequest } from '@servicetitan/financing-api-client';
import { ApplicationData } from '../application/ApplicationDataStore';
import { calculateIncomes } from '../../utils/calculateIncomes';

export interface PrepareSubmitPrequalRequestParams {
    applicationData: ApplicationData;
    providerName: string;
    tenantId: string;
    buId: string;
    requestedAmount: number;
    planNumbers?: string[];
    hasMailingAddressStep?: boolean;
    prequalLinkId?: string | null;
    iovationBlackbox?: string | null;
}

const sanitizeSSN = (ssn: string | undefined): string | undefined => {
    if (!ssn) {
        return undefined;
    }
    return ssn.replace(/-/g, '');
};

const sanitizePhone = (phone: string | undefined): string | undefined => {
    if (!phone) {
        return undefined;
    }
    const digits = phone.replace(/\D/g, '');
    return digits.length > 0 ? digits : undefined;
};

export const prepareSubmitPrequalRequest = ({
    applicationData,
    providerName,
    tenantId,
    buId,
    requestedAmount,
    planNumbers,
    hasMailingAddressStep,
    prequalLinkId,
    iovationBlackbox,
}: PrepareSubmitPrequalRequestParams): SubmitPrequalRequest => {
    const primaryApplicantData = applicationData.applicant.primaryApplicant;
    const primaryJobDetails = primaryApplicantData?.jobDetails;
    const jobAddress = primaryJobDetails?.address;

    const homeAddress = hasMailingAddressStep
        ? applicationData.mailingAddress.primaryApplicant?.address
        : primaryJobDetails?.mailingAddressDiffersFromJobAddress
          ? primaryJobDetails?.mailingAddress?.address
          : jobAddress;

    const { grossMonthlyIncome = 0 } = calculateIncomes({
        grossMonthlyIncome: primaryApplicantData?.employment?.grossMonthlyIncome,
        annualIncome: primaryApplicantData?.annualIncome,
    });

    return {
        providerName,
        tenantId,
        buId,
        prequalLinkId: prequalLinkId ?? null,
        firstName: primaryApplicantData?.firstName ?? null,
        middleInitial: primaryApplicantData?.middleInitial ?? null,
        lastName: primaryApplicantData?.lastName ?? null,
        dateOfBirth: primaryApplicantData?.dateOfBirth ?? '',
        ssn: sanitizeSSN(primaryApplicantData?.ssn) ?? null,
        emailAddress: primaryApplicantData?.email ?? null,
        primaryPhone: sanitizePhone(primaryApplicantData?.primaryPhone) ?? null,
        iovationBlackbox: iovationBlackbox ?? null,
        address: (homeAddress as Address) ?? null,
        grossMonthlyIncome,
        requestedAmount,
        planNumbers: planNumbers ?? null,
    };
};
